{
  "notifications": {
    "roleAssigned": {
      "title": "You've successfully assigned {{role}} role",
      "description": "You've successfully assigned {{role}} role to {{email}} user",
      "failed": "Failed to assign {{role}} role"
    },
    "roleAssignmentFailed": {
      "description": "Something went wrong while updating the role. Please try again."
    }
  },
  "pages": {
    "teamMembers": {
      "title": "Team members",
      "tabs": {
        "yourOrganization": "Your organization",
        "sib": "SIB"
      },
      "aboutRulesModalTitle": "learn more about roles",
      "loggedInUsers": "{{count}} / {{max}} invited users have logged in"
    }
  },
  "tooltips": {
    "userLoggedIn": "User logged in",
    "cannotChangeOwnRole": "You cannot change your own role",
    "cannotChangeOnlyAdminRole": "You cannot change the only admin role"
  },
  "modal": {
    "rolesInfo": {
      "title": "Roles within SpendBrain",
      "subtitle": "Learn more about the user roles and their differences within the SpendBain",
      "admin": {
        "title": "Admin",
        "subtitle": "Short explanation",
        "descriptionList": [
          "Access to sensitive documents",
          "Ability to manage user access and permissions",
          "Possibility of activating new spend areas for customers"
        ]
      },
      "standardUser": {
        "title": "Standard User",
        "subtitle": "Short explanation",
        "descriptionList": [
          "Lack of access to sensitive documents",
          "Lack of ability to manage user access and permissions",
          "Lack of possibility of activating new spend areas for customers"
        ]
      }
    },
    "roleAssignConfirm": {
      "customerAdmin": {
        "title": "You are about to assign the {{role}} role to this user",
        "description": {
          "title": "This will grant:",
          "list": [
            "Access to sensitive documents",
            "Permission to manage users and access levels",
            "Possibility of activating new spend areas for customers"
          ],
          "footer": {
            "title": "Admins have full administrative copabilities within the organization.",
            "footerConfirm": "Do you want to proceed?"
          }
        }
      },
      "standardUser": "@:modal.roleAssignConfirm.commonCustomer",
      "commonCustomer": {
        "title": "You are about to change this user's role from Admin to {{role}}",
        "description": {
          "title": "This will remove administrative permissions, including:",
          "list": [
            "Access to sensitive documents",
            "Ability to manage user access and permissions",
            "Possibility of activating new spend areas for customers"
          ],
          "footer": {
            "title": "The user will no longer be able to perform administrative actions.",
            "footerConfirm": "Are you sure you want to continue?"
          }
        }
      },
      "cancel": "Cancel",
      "confirm": "Confirm"
    }
  },
  "components": {
    "sections": {
      "admins": "Admins",
      "standardUsers": "Standard users",
      "primaryContact": "Primary contact",
      "otherMembers": "Other supporting members",
      "billing": "Billing"
    },
    "roles": {
      "customerAdmin": "Admin",
      "commonCustomer": "Standard User",
      "standardUser": "@:components.roles.commonCustomer"
    },
    "statuses": {
      "available": "Available",
      "outOfOffice": "Out of office"
    },
    "actions": {
      "scheduleMeeting": "Schedule meeting",
      "roleChanged": "Role updated successfully"
    },
    "contactListPlaceholder": {
      "admins": {
        "title": "No admins",
        "subtitle": "There are no admins in your organisation yet. Admins will appear here once they are added."
      },
      "standardUsers": {
        "title": "No standard users",
        "subtitle": "There are no standard users in your organisation yet. Users will appear here once they are added."
      },
      "primaryContact": {
        "title": "No active primary contact",
        "subtitle": "There is currently no active primary contact. A new contact will appear here once it is assigned."
      },
      "otherMembers": {
        "title": "No other supporting members",
        "subtitle": "There are currently no supporting members. Any new members will appear here once they are added."
      },
      "billing": {
        "title": "No active billing contacts",
        "subtitle": "There are currently no active billing contacts. A new contact will appear here once it is assigned."
      }
    }
  }
}
